import {Component, OnInit, ViewChild} from '@angular/core';
import {EventService} from "../../../service/api/event.service";
import {ActivatedRoute, Router} from "@angular/router";
import {EventResponse} from "../../../shared/model/response/event/event-response.model";
import {ContactrequestComponent} from "./contactrequest/contactrequest.component";
import {AuthenticationService} from "../../../service/authentication-service";
import {AuthtokenResponse} from "../../../shared/model/response/auth/authtoken-response.model";
import {MenuItem} from "primeng/api";
import {EventUtilService} from "../../../service/utils/event-util.service";
import {EventStatus} from "../../../shared/enums/status.enum";
import {ConstantsEnum} from "../../../shared/enums/constants-enum";

@Component({
    selector: 'app-eventdetail',
    templateUrl: './event-detail.component.html',
    standalone: false
})
export class EventDetailComponent implements OnInit {

  public event: EventResponse;

  public mouseEvent: MouseEvent

  public isEventLoading: boolean = true

  public isTerminated: boolean = false

  public isAuthenticated: boolean = false
  public authUser: AuthtokenResponse

  public imageToDisplay

  @ViewChild(ContactrequestComponent) childComponent: ContactrequestComponent;

  items: MenuItem[] | undefined;
  value: any;
  showAdjustmentModal: boolean;

  notInformedText = ConstantsEnum.NOT_INFORMED

  constructor(
    private eventService: EventService,
    private eventUtilService: EventUtilService,
    private authService: AuthenticationService,
    private route: Router,
    private activeRoute: ActivatedRoute) {
  }

  ngOnInit(): void {

    this.imageToDisplay = this.displayEventImage()

    this.isAuthenticated = this.authService.isAuthenticated();
    this.authUser = this.authService._user.getValue();

    //get the event
    const slug = this.activeRoute.snapshot.params['slug']
    this.loadEvent(slug)
  }


  displayEventImage(): string {
    return this.eventUtilService.displayEventImage(this.event);
  }

  /**
   * loads an event from the backend
   * @param slug the slug to identify the event.
   */
  loadEvent(slug: string): void {
    this.eventService.getEventBySlug(slug).subscribe({
      next: (event) => {

        this.isEventLoading = false

        if (event.status?.code === EventStatus.CLOSED) {
          this.isTerminated = true
        } else {
          this.event = event
        }
      },
      error: () => this.route.navigate(['**'], {skipLocationChange: true})
    });
  }

  /** Opens the contact Request dialog.*/
  showContactDialog() {
    if (!this.isAuthenticated) {
      //todo: can I get the information from the routes?
      this.route.navigate(['/acesso']).then()
    }
    this.childComponent.loadDialog();
  }

  setMouseEvent(ev: Event) {
    this.mouseEvent = ev as MouseEvent
  }

  displayStatusToolTip(): string {
    switch (this.event?.status.code) {
      case EventStatus.PENDING:
        return "A ocorrência está visível ao mundo. A imagem está pendente de uma avaliação"
      case EventStatus.ACTIVE:
        return "A ocorrência está visível ao mundo"
      case EventStatus.ADJUSTMENT:
        return "Foram encontrados pontos de ajuste, clique para ler a mensagem do moderador"
    }
    return null
  }

  showAdjustmentMessage() {
    if (this.event?.status?.code == "ADJUSTMENT") {
      this.showAdjustmentModal = true
    }
  }

  onCloseEvent(){
    this.isTerminated = true
  }

  onModalEventRemove(){
    this.route.navigate(["/perfil/ocorrencias"])
  }
}
